import { client } from './client'

const fetchDataBuckets = async () => {
  try {
    let response = await client.get('/v1/databuckets')
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchSimCustomer = async () => {
  try {
    let response = await client.get('/v1/customer/SimCustomer')
    return response.data
  } catch (error) {
    throw error
  }
}

export {
  fetchDataBuckets,
  fetchSimCustomer
}



// WEBPACK FOOTER //
// ./src/api/mvno/index.js